import React, { useState, useEffect } from 'react';
import './RegistrationForm.css';
import { db } from "../../../config/firebase";
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { BsCheckCircleFill } from 'react-icons/bs'
import { useHistory } from 'react-router-dom'

const schema = yup.object({
  Name: yup.string().required(),
  Email: yup.string().email().required(),
  Contact: yup.string().length(10).required(),
  Age: yup.number().min(1).max(60).positive().integer().required(),
  Profession: yup.string().required()
}).required()




const RegisterationForm = () => {


  const history = useHistory()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const [success, setSuccess] = useState(false)

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  })

  const onSubmit = (data) => {
    db.collection("contacts").doc(data.Email).set(data)
      .then(() => {
        setSuccess(true)
        sessionStorage.setItem('user', data.Email)
        setTimeout(() => {
          history.push('/tests')
        }, 2000)
      })
      .catch((error) => {
        alert(error.message);
      });

    window.scrollTo(0, 0)
  }

  return (
    <>
      <div className='form-container'>
        <form className="form" onSubmit={handleSubmit(onSubmit)}>
          {
            success ?
              <div style={{ textAlign: 'center' }}>
                <BsCheckCircleFill size={40} color='green' />
                <div>Your registration is successful</div>
                <br />
                <div>redirecting...</div>
              </div>
              :
              <>

                <h2 style={{ textAlign: 'center' }}>Register Here</h2>

                <div className='form-item'>
                  <label>Full name <span style={{ color: 'red' }}>*</span></label>
                  <input type="text" className='form-input' placeholder="Enter full name" name="Name"
                    {...register("Name")} />
                  <div style={{ fontSize: '2vh', color: 'red', marginTop: '0.5vh' }}>{errors.Name?.message}</div>
                </div>

                <div className='form-item'>
                  <label className='form-item'>Email <span style={{ color: 'red' }}>*</span></label>
                  <input type="text" className='form-input' placeholder="Enter email address" name="Email"
                    {...register("Email")} />
                  <div style={{ fontSize: '2vh', color: 'red', marginTop: '0.5vh' }}>{errors.Email?.message}</div>
                </div>

                <div className='form-item'>
                  <label className='form-item'> Contact Number <span style={{ color: 'red' }}>*</span> </label>
                  <input type="text" className='form-input' placeholder="Enter phone number" name="Contact"
                    {...register("Contact")} />
                  <div style={{ fontSize: '2vh', color: 'red', marginTop: '0.5vh' }}>{errors.Contact?.message}</div>
                </div>

                <div className='form-item'>
                  <label className='form-item'> Age <span style={{ color: 'red' }}>*</span></label>
                  <input type="text" className='form-input' placeholder="Enter age" name="Age"
                    {...register("Age")} />

                  <div style={{ fontSize: '2vh', color: 'red', marginTop: '0.5vh' }}>{errors.Age?.message.slice(0, 27)}</div>



                  <div className='form-item'>
                    <label className='form-item'> Function <span style={{ color: 'red' }}>*</span></label>
                    <input type="text" className='form-input' placeholder="Enter Function" name="Profession"
                      {...register("Profession")} />
                    <div style={{ fontSize: '2vh', color: 'red', marginTop: '0.5vh' }}>{errors.Profession?.message}</div>
                  </div>

                  <div className='form-item'>
                    <input className='form-button' type="submit" />
                  </div>
                </div>
              </>
          }
        </form>
      </div>
    </>
  );
};

export default RegisterationForm;